module.exports = __webpack_public_path__ + "static/img/图片1.80aa9cf7.png";